module.exports = __webpack_public_path__ + "img/86ff75ea7e280b38143e6270c46241e5-1.678992fc.png";